import axios from "@/axios.js"

export default {
    add({commit}, item) {
        return new Promise((resolve, reject) => {
            axios.post("/customer/ticket/add", item)
                .then((response) => {
                    commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    view({commit} , item){
        commit('VIEW_MODEL', item);
    },
    getData({commit} , id){
        return new Promise((resolve, reject) => {
            axios.post("/customer/ticket/get" , {id:id})
                .then((response) => {
                    commit('VIEW_MODEL', response.data);
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getChildren({commit} , id){
        return new Promise((resolve, reject) => {
            axios.post("/customer/ticket/get-children" , {id:id})
                .then((response) => {
                    commit('GET_CHILDREN', response.data);
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    fetch({commit} , data) {
        return new Promise((resolve, reject) => {
            axios.get("/customer/ticket" , {params:data})
                .then((response) => {
                    commit('SET_LIST', response.data)
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
}
